import { t } from "@/i18n-js/instance";
import { FormTopicsPicker } from "@/react/components/QuickPostV2/Content/TopicsPicker/FormTopicsPicker";
import { Form } from "@circle-react-shared/uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";

export const ReorderTopics = () => (
  <>
    <Typography.TitleMd color="text-darkest">
      {t("courses.directory.options_modal.reorder_topics.title")}
    </Typography.TitleMd>
    <Typography.BodyMd color="text-default">
      {t("courses.directory.options_modal.reorder_topics.subtitle")}
    </Typography.BodyMd>
    <Form.Item name="topics_order" hideDescription hideBorder>
      <FormTopicsPicker
        containerClassName="bg-primary border-primary rounded-md border mb-8"
        sortable
        maxTopicsAllowed={0}
        deletable={false}
        creatable={false}
        name="topics_order"
      />
    </Form.Item>
  </>
);
